export default __webpack_public_path__ + "static/media/realtime_searching.ad22cd18.gif";